/**
 * Which links the in-page router is allowed to take over.
 *
 * preact-iso hijacks EVERY same-origin `<a>` click and routes it inside the page. That is right for a
 * page and wrong for anything the server has to answer: a `/api/...` link was matched against the route
 * table, matched nothing, and rendered "page not found" instead of ever leaving the browser. It cost the
 * event-day queue link, and it would have cost the next one somebody added.
 *
 * So: rooted paths stay in the router's hands, `/api/` and `/media/` belong to the server. Every
 * internal link in this app is written rooted, so nothing else changes. An individual link can still opt
 * out with `target="_top"`, which the login buttons and the queue link both do.
 */
export const ROUTER_SCOPE = /^\/(?!api\/|media\/)/;

/** What preact-iso will decide for this href — exported so the rule can be tested rather than trusted. */
export const routerHandles = (href: string): boolean => ROUTER_SCOPE.test(href);
